import mockAxios, { AxiosResponse } from 'axios';
import { IHarmonizedSystemServiceMock } from './harmonized-system.mock.types';

export const mockHarmonizedSystemService = (): IHarmonizedSystemServiceMock => ({
  fetchHSCodes: jest.fn(),
  fetchHSCode: jest.fn(),
  createHSCode: jest.fn(),
  updateHSCode: jest.fn(),
  deleteHSCode: jest.fn(),
  uploadHSCodes: jest.fn()
});

export function mockHarmonizedSystemAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
